import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  const totalSpots = 200;
  const [spotsLeft, setSpotsLeft] = useState(17); // Start with a low number to create urgency
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    // Occasionally decrease spots left
    const spotsTimer = setInterval(() => {
      setSpotsLeft(prev => prev > 3 ? prev - 1 : prev);
    }, 45000);
    return () => {
      clearInterval(timer);
      clearInterval(spotsTimer);
    };
  }, []);
  const progressPercentage = (totalSpots - spotsLeft) / totalSpots * 100;
  return <div className="w-full max-w-md mx-auto bg-red-50 border border-red-200 rounded-xl p-6 my-8 shadow-sm" data-id="element-34">
      <div className="text-center mb-4" data-id="element-35">
        <h3 className="text-red-600 font-bold text-lg mb-1" data-id="element-36">
          ¡OFERTA POR TIEMPO LIMITADO!
        </h3>
        <p className="text-gray-700 text-sm" data-id="element-37">
          Los bonos gratuitos desaparecen en:
        </p>
      </div>

      <div className="flex justify-center gap-4 mb-6" data-id="element-38">
        <div className="flex flex-col items-center" data-id="element-39">
          <div className="bg-white text-red-600 font-black text-3xl w-16 h-16 flex items-center justify-center rounded-lg shadow-sm border border-red-100" data-id="element-40">
            {String(timeLeft.hours).padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 uppercase font-bold" data-id="element-41">
            Horas
          </span>
        </div>
        <div className="text-red-600 font-black text-3xl mt-3" data-id="element-42">:</div>
        <div className="flex flex-col items-center" data-id="element-43">
          <div className="bg-white text-red-600 font-black text-3xl w-16 h-16 flex items-center justify-center rounded-lg shadow-sm border border-red-100" data-id="element-44">
            {String(timeLeft.minutes).padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 uppercase font-bold" data-id="element-45">
            Min
          </span>
        </div>
        <div className="text-red-600 font-black text-3xl mt-3" data-id="element-46">:</div>
        <div className="flex flex-col items-center" data-id="element-47">
          <div className="bg-white text-red-600 font-black text-3xl w-16 h-16 flex items-center justify-center rounded-lg shadow-sm border border-red-100" data-id="element-48">
            {String(timeLeft.seconds).padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 uppercase font-bold" data-id="element-49">
            Seg
          </span>
        </div>
      </div>

      <div className="space-y-2" data-id="element-50">
        <div className="flex justify-between text-sm font-bold text-gray-700" data-id="element-51">
          <span data-id="element-52">Cupos disponibles:</span>
          <span className="text-red-600" data-id="element-53">
            {spotsLeft} de {totalSpots}
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden" data-id="element-54">
          <div className="bg-red-600 h-3 rounded-full transition-all duration-1000 ease-out" style={{
          width: `${progressPercentage}%`
        }} data-id="element-55"></div>
        </div>
        <p className="text-xs text-center text-gray-500 mt-2" data-id="element-56">
          Más del 90% de los cupos con bonos ya fueron reclamados
        </p>
      </div>
    </div>;
}